import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Notification } from '../../../common/notification'
import { Panel } from '../../../common/panel'
import { Table } from '../../../common/table'
import { AlertTabs } from './AlertTabs'
import { TableCell } from './TableCell'
import { ALERT_TYPES, COLUMN_IDS, SENTIMENT_TYPE_ID } from './constant'
import classes from './index.module.scss'
import {
  resetStore,
  selectCompanyAlerts,
  selectCompanyAlertsById,
  selectLoading,
} from './store/slice'
import { getAlertHighlight, getCompanyAlerts } from './store/thunk'

export const Alerts = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectCompanyAlerts())
  const isLoading = useSelector(selectLoading('companyAlerts'))

  const [alertType, setAlertType] = useState(ALERT_TYPES.TOTAL)

  useEffect(() => {
    dispatch(getAlertHighlight())
  }, [])

  useEffect(() => {
    dispatch(
      getCompanyAlerts({
        readStatus: alertType === ALERT_TYPES.UNREAD ? false : undefined,
        sentimentId:
          alertType === ALERT_TYPES.NEGATIVE
            ? [SENTIMENT_TYPE_ID.NEGATIVE]
            : undefined,
        page: 1,
        pageSize: 5,
      }),
    )
  }, [alertType, locale])

  useEffect(() => {
    return () => resetStore()
  }, [])

  const renderLabel = () => (
    <>
      &nbsp;
      <Translate
        value="portfolio.summary.FILTER_ARE_NOT_APPLIED"
        className="fstItalic"
        style={{ textTransform: 'none' }}
      />
    </>
  )

  const schema = Object.keys(COLUMN_IDS).map((key) => {
    const colId = COLUMN_IDS[key]
    const title = 'portfolio.summary.' + key

    return {
      colId,
      title,
      isI18n: true,
      render: (data, { rowId, rowIndex }) => (
        <TableCell
          data={data}
          colId={colId}
          rowId={rowId}
          rowIndex={rowIndex}
        />
      ),
    }
  })

  const onRowClick = (rowId) => {
    window.open(`/alerts/${rowId}`, '_blank').focus()
  }

  return (
    <Panel
      label="portfolio.summary.ALERTS"
      isI18n
      renderLabel={renderLabel}
      headerStyle={{ textTransform: 'capitalize' }}
    >
      <div className={classes.container}>
        <AlertTabs alertType={alertType} setAlertType={setAlertType} />
        <Element className="flex1 minH0 positionRelative">
          {!isLoading && (!data || !Object.keys(data).length) ? (
            <div className="py3">
              <Notification />
            </div>
          ) : (
            <Table
              ids={data.map((i) => i.recordId)}
              getDataFromRedux={selectCompanyAlertsById}
              schema={schema}
              onRowClick={onRowClick}
              autoHeightMax={300}
            />
          )}
        </Element>
      </div>
    </Panel>
  )
}
